__turbopack_context__.v({
  "chevron": "menu-module__lkhdNW__chevron",
  "hamburger": "menu-module__lkhdNW__hamburger",
  "items": "menu-module__lkhdNW__items",
  "logo": "menu-module__lkhdNW__logo",
  "menuButton": "menu-module__lkhdNW__menuButton",
  "menuButtonContent": "menu-module__lkhdNW__menuButtonContent",
  "menuContainer": "menu-module__lkhdNW__menuContainer",
  "menuItemContainer": "menu-module__lkhdNW__menuItemContainer",
  "menuItemWithSubmenu": "menu-module__lkhdNW__menuItemWithSubmenu",
  "menuLink": "menu-module__lkhdNW__menuLink",
  "selected": "menu-module__lkhdNW__selected",
  "stuck": "menu-module__lkhdNW__stuck",
  "submenu": "menu-module__lkhdNW__submenu",
  "submenuItem": "menu-module__lkhdNW__submenuItem",
  "submenuVisible": "menu-module__lkhdNW__submenuVisible",
});
